import { render, staticRenderFns } from "./DashTV.vue?vue&type=template&id=2911fdd5&class=true&"
import script from "./DashTV.vue?vue&type=script&lang=js&"
export * from "./DashTV.vue?vue&type=script&lang=js&"
import style0 from "./DashTV.vue?vue&type=style&index=0&id=2911fdd5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports